import Head from 'components/Head';
import Footer from 'components/Footer';
import ApplyForm from './components/applyForm';
import LiveVideo from './components/liveVideo';
import LiveIcon from '../../components/liveIcon.vue';
import { getUrlParams } from '@/plugins/utils';
import { SuccessFilled, Clock, CircleCloseFilled } from '@element-plus/icons-vue';
import ApplyDrawDialog from '../lectureList/components/ApplyDrawDialog.vue';
import DrawResultDialog from '../lectureList/components/DrawResultDialog.vue';
export default {
  components: {
    Head,
    Footer,
    ApplyForm,
    LiveVideo,
    LiveIcon,
    SuccessFilled,
    Clock,
    CircleCloseFilled,
    ApplyDrawDialog,
    DrawResultDialog
  },

  data() {
    return {
      menuId: getUrlParams('menuId'),
      menuName: decodeURIComponent(getUrlParams('name')),
      lectureInfo: {},
      statusText: '未开始',
      userInfo: {},
      showApplyDialog: false,
      liveId: getUrlParams('id'),
      showResultDialog: false,
      ballotStatus: 0 // 抽签结果

    };
  },

  computed: {
    // is_draw 活动抽签 0.不启用 1.启用
    // applicantsStatus 报名状态 0 未报名  1 已报名
    // live_status 	直播状态 线上 （ 0:未开始 2:已结束  -2:进行中 3：回放生成中（配合type） 4 ：回放以生成（配合type））  线下（0:未开始 2:已结束  -2:进行中）
    // applicants_time_status 0报名时间未到 1可以开始报名 2 报名已结束
    // is_applicants 活动报名 0.不启用 1.启用
    getApplyFormStatus() {
      if (this.lectureInfo.is_draw == 1) {
        if (this.lectureInfo.live_status == 0 && this.lectureInfo.draw_type == 5 && this.lectureInfo.applicants_time_status == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.lectureInfo.live_status == 0 && this.lectureInfo.applicantsStatus == 0) {
          return this.lectureInfo.is_applicants == 1 ? this.lectureInfo.applicants_time_status == 1 ? true : false : true;
        } else {
          return false;
        }
      }
    },

    // 格式化培训时间
    formatTrainTime() {
      if (this.lectureInfo.start_time && this.lectureInfo.end_time) {
        let startDay = this.$dayjs(this.lectureInfo.start_time).date(); // 获取日

        let endDay = this.$dayjs(this.lectureInfo.end_time).date();

        if (startDay === endDay) {
          return this.$dayjs(this.lectureInfo.start_time).format('YYYY年MM月DD日 HH:mm') + ' - ' + this.$dayjs(this.lectureInfo.end_time).format('HH:mm');
        } else {
          return this.$dayjs(this.lectureInfo.start_time).format('YYYY年MM月DD日 HH:mm') + ' - ' + this.$dayjs(this.lectureInfo.end_time).format('YYYY年MM月DD日 HH:mm');
        }
      }
    }

  },
  methods: {
    // draw_type 1 报名完抽签成功 2 报名成功未抽中 3报名完成等待抽签 4报名成功可以开始抽签 5未报名
    formateDrawStatus(type) {
      if (type == 1) {
        return '已成功报名，请按时参加';
      } else if (type == 2) {
        return '未抽中，欢迎关注后续活动';
      } else if (type == 3) {
        return '已报名，请关注后续报名抽签';
      } else {
        return '已报名，请参与报名抽签';
      }
    },

    // 抽签结果
    ballotResult(result) {
      this.ballotStatus = result;
      this.showResultDialog = true;
      this.getLectureInfo();
    },

    getUserInfo(item) {
      this.userInfo = item;
    },

    // 返回
    handleBack() {
      window.location.href = `/lectureList.html?menuId=${this.menuId}&name=${this.menuName}`;
    },

    // 直播观看记录统计
    async trainViewerRecord() {
      await this.$http.trainViewerRecord({
        id: getUrlParams('id') || ''
      });
    },

    // 获取培训研讨信息
    async getLectureInfo() {
      let lectureInfo = await this.$http.getLectureDetail({
        id: getUrlParams('id') || ''
      });
      this.lectureInfo = lectureInfo;

      if (this.lectureInfo.live_status == 0) {
        this.statusText = this.lectureInfo.type == 1 ? '直播未开始' : '未开始';
      } else if (this.lectureInfo.live_status == -2) {
        if (this.lectureInfo.type === 1) {
          this.trainViewerRecord();
          this.statusText = '直播中';
        } else {
          this.statusText = '进行中';
        }
      } else if (this.lectureInfo.live_status > 1) {
        this.statusText = this.lectureInfo.type === 1 ? '直播已结束' : '已结束';
      }
    }

  },

  created() {
    this.getLectureInfo();
  }

};